import React from 'react';
import {
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
  CogIcon,
  DocumentTextIcon,
  CircleStackIcon,
  NoSymbolIcon,
} from '@heroicons/react/24/outline';

// Stage badges deliberately use the light-bg + dark-text pattern so they pop
// off the dark vault background — same approach as SCGConflictsPanel's
// severity / verdict badges.
const STAGE_META = {
  queued:     { label: 'Queued',     bg: 'bg-gray-200',    text: 'text-gray-800',     Icon: ClockIcon },
  parsing:    { label: 'Parsing',    bg: 'bg-amber-100',   text: 'text-amber-800',    Icon: DocumentTextIcon },
  extracting: { label: 'Extracting', bg: 'bg-blue-100',    text: 'text-blue-800',     Icon: CogIcon },
  indexing:   { label: 'Indexing',   bg: 'bg-indigo-100',  text: 'text-indigo-800',   Icon: CircleStackIcon },
  completed:  { label: 'Completed',  bg: 'bg-emerald-100', text: 'text-emerald-800',  Icon: CheckCircleIcon },
  failed:     { label: 'Failed',     bg: 'bg-red-100',     text: 'text-red-800',      Icon: XCircleIcon },
  cancelled:  { label: 'Cancelled',  bg: 'bg-gray-200',    text: 'text-gray-600',     Icon: NoSymbolIcon },
};

export default function BulkSCGFileRow({ file }) {
  const meta = STAGE_META[file.stage] || STAGE_META.queued;
  const Icon = meta.Icon;
  return (
    <tr className="border-b last:border-b-0 border-[var(--vault-border)]">
      <td
        className="px-3 py-2 text-sm text-[var(--text-primary)] truncate max-w-md"
        title={file.filename}
      >
        {file.filename}
      </td>
      <td className="px-3 py-2">
        <span
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${meta.bg} ${meta.text}`}
        >
          <Icon className="w-3.5 h-3.5" />
          {meta.label}
        </span>
      </td>
      <td className="px-3 py-2 text-sm text-[var(--text-secondary)] text-right tabular-nums">
        {file.rule_count != null ? file.rule_count : '—'}
      </td>
      <td className="px-3 py-2 text-sm text-[var(--text-muted)] tabular-nums">
        {file.attempts > 1 ? `${file.attempts}×` : ''}
      </td>
      <td
        className="px-3 py-2 text-xs text-[#e57373] max-w-sm truncate"
        title={file.error_reason || ''}
      >
        {file.error_reason || ''}
      </td>
    </tr>
  );
}
